import React, { useState, useEffect } from "react";
import Sidebar from "../../../partials/aside/Sidebar";
import { Link } from "react-router-dom";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";
import Pagination from "../../../partials/content/Pagination";

function AllCategoriesSitePublisher() {
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [categoryNameSearchFilter, setCategoryNameSearchFilter] = useState();
  const [categoryIDSearchFilter, setCategoryIDSearchFilter] = useState();

  useEffect(() => {
    getCategoryAllPublisher();
  }, [currentPage, categoryNameSearchFilter, categoryIDSearchFilter]);

  const getCategoryAllPublisher = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultRequestGetCategories = await sendRequestGetCategories(
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultRequestGetCategories) {
      return;
    }

    setCategories(resultRequestGetCategories.category_site_publisher);
    setCountPage(resultRequestGetCategories.count_page);
  };

  const sendRequestGetCategories = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let categories;
    try {
      categories = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/category-site-publishers/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return categories.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const deleteCategoryPublisher = async (categoryID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (await sendRequestDeleteCategoryAllPublisher(categoryID)) {
      getCategoryAllPublisher();
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequestDeleteCategoryAllPublisher = async (categoryID) => {
    const headersRequest = getHeaderForRequest();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/category-site-publishers/" +
          categoryID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return true;
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (categoryNameSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&name=${categoryNameSearchFilter}`;
    }
    if (categoryIDSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&id=${categoryIDSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const generateTagCategories = () => {
    return (
      <>
        <div className="alert alert-info">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در شماره صنفی</label>
              </div>
              <div>
                <input
                  onKeyUp={(e) => setCategoryIDSearchFilter(e.target.value)}
                  onWheel={(event) => event.currentTarget.blur()}
                  className="form-control"
                  type="number"
                />
              </div>
              <div className="pl-2">
                <label>جستجو در نام دسته صنفی</label>
              </div>
              <div>
                <input
                  onKeyUp={(e) => setCategoryNameSearchFilter(e.target.value)}
                  className="form-control"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره</td>
                <td>نام</td>
                <td>تعداد سایت های زیر دسته</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {categories.map((category, index) => {
                return (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{category.cas_id}</td>
                    <td>{category.cas_name}</td>
                    <td>
                      {category.count_site_publisher_that_belong_category}
                    </td>
                    <td>
                      <div>
                        <span className="pl-2">
                          <Link
                            to={`/manage/category-publishers/edit/${category.cas_id}`}
                            className="btn btn-success  "
                          >
                            <i className="fa fa-edit"></i>
                          </Link>
                        </span>

                        {/* <span>
                            <span
                              className="btn btn-danger  btn-danger"
                              onClick={() => {
                                deleteCategoryPublisher(category.cas_id);
                              }}
                            >
                              <i className="fa fa-trash"></i>
                            </span>
                          </span> */}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  return (
    <>
      <Sidebar
        openItem="manage-category-publisher-menu"
        activeItem="manage-category-publisher"
      />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">مدیریت دسته های صنفی</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <Link
                className="btn btn-info mb-2"
                to="/manage/category-publishers/add"
              >
                <span className="pl-2">
                  <i className="fa fa-plus"></i>
                </span>
                <span>اضافه کردن دسته صنفی</span>
              </Link>

              {categories.length == 0 &&
              categoryNameSearchFilter == null &&
              categoryIDSearchFilter == null ? (
                <></>
              ) : (
                generateTagCategories()
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllCategoriesSitePublisher;
